import type React from 'react';

interface EditProfileIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function EditProfileIcon({ className = '', ...props }: EditProfileIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M1.875 18.0006V6.00057C1.875 3.7224 3.72183 1.87557 6 1.87557H9C9.62132 1.87557 10.125 2.37925 10.125 3.00057C10.125 3.62189 9.62132 4.12557 9 4.12557H6C4.96447 4.12557 4.125 4.96504 4.125 6.00057V18.0006C4.125 19.0361 4.96447 19.8756 6 19.8756H18C19.0355 19.8756 19.875 19.0361 19.875 18.0006V15.0006C19.875 14.3793 20.3787 13.8756 21 13.8756C21.6213 13.8756 22.125 14.3793 22.125 15.0006V18.0006C22.125 20.2787 20.2782 22.1256 18 22.1256H6C3.72183 22.1256 1.875 20.2787 1.875 18.0006Z"
        fill="#FAFAFA"
      />
      <path
        d="M14.8315 3.8326C15.2436 3.42057 15.8955 3.39414 16.3374 3.75497L16.4224 3.8326L20.1724 7.5826L20.25 7.66757C20.6101 8.10943 20.5841 8.76166 20.1724 9.17342C19.7604 9.58528 19.1083 9.61027 18.6665 9.2496L18.5815 9.17342L14.8315 5.42343L14.7539 5.337C14.3938 4.89519 14.4199 4.24439 14.8315 3.8326Z"
        fill="#FAFAFA"
      />
      <path
        d="M17.1024 1.57923C18.3298 0.57828 20.1405 0.650507 21.2845 1.79457L22.2059 2.71595L22.4213 2.95326C23.4221 4.18067 23.35 5.99135 22.2059 7.13539L13.8109 15.5319C13.2789 16.0639 12.6125 16.4387 11.8861 16.6188L11.5712 16.6832L9.40026 17.0451C7.96242 17.2843 6.71613 16.0381 6.95544 14.6002L7.31725 12.4293C7.45859 11.5813 7.86069 10.7975 8.46862 10.1896L16.8651 1.79457L17.1024 1.57923ZM19.6937 3.38539C19.3948 3.0865 18.9332 3.04861 18.5936 3.27259L18.4559 3.38539L10.0609 11.7819C9.78466 12.0581 9.60079 12.4131 9.53649 12.7985L9.20251 14.7965L11.202 14.464C11.5874 14.3997 11.9424 14.2158 12.2186 13.9396L20.6151 5.54457C20.914 5.24571 20.9518 4.78406 20.7279 4.44447L20.6151 4.30677L19.6937 3.38539Z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
